import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-export-destination',
  templateUrl: './help-add-export-destination.component.html',
  styleUrls: ['./help-add-export-destination.component.scss']
})
export class HelpAddExportDestinationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
